import React from 'react';

import { 
  Box, 
  Divider, 
  Typography
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HubIcon from '@mui/icons-material/Hub';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AttachEmailOutlinedIcon from '@mui/icons-material/AttachEmailOutlined';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import BroadcastOnHomeOutlinedIcon from '@mui/icons-material/BroadcastOnHomeOutlined';
import RateReviewOutlinedIcon from '@mui/icons-material/RateReviewOutlined';
import MarkUnreadChatAltOutlinedIcon from '@mui/icons-material/MarkUnreadChatAltOutlined';
import PasswordOutlinedIcon from '@mui/icons-material/PasswordOutlined';

import "../styles.scss";

const Notifications = ({
  navigate, 
  currentPage
}) => {
  return (
    <Box className="nav__side-common" 
      display={"flex"} flexDirection={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`nav__side-item flexCenter_Row`}
          onClick={() => {
            navigate("/business");
          }}>
          <ArrowBackIcon />
          <Typography variant='body2'>
            Back
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 7 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications");
          }}>
          <HubIcon />
          <Typography variant='body2'>
            Overview
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/email-activities");
          }}>
          <AttachEmailOutlinedIcon />
          <Typography variant='body2'>
            Email Activities
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/email-templates");
          }}>
          <EmailOutlinedIcon />
          <Typography variant='body2'>
            Email Templates
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 8 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/email-template-sync");
          }}>
          <CloudSyncOutlinedIcon />
          <Typography variant='body2'>
            Template Sync
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/email-tester");
          }}>
          <BugReportOutlinedIcon />
          <Typography variant='body2'>
            Email Tester
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/email-broadcast");
          }}>
          <BroadcastOnHomeOutlinedIcon />
          <Typography variant='body2'>
            Email Broadcaster
          </Typography>
        </Box>
      </Box>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/sms-templates");
          }}>
          <RateReviewOutlinedIcon />
          <Typography variant='body2'>
            Sms Templates
          </Typography>
        </Box>
        <Divider />
        <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/sms-activities");
          }}>
          <MarkUnreadChatAltOutlinedIcon />
          <Typography variant='body2'>
            Sms Activities
          </Typography>
        </Box>
      </Box>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 6 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/notifications/otp-records");
          }}>
          <PasswordOutlinedIcon />
          <Typography variant='body2'>
            OTP Records
          </Typography>
        </Box>
      </Box>
    </Box> 
  )
}

export default Notifications;